<template lang="pug">
  b-row
    b-col(md="4")
    b-col(cols="12" md="4")
      form(@submit.prevent="login")
        h2 Ingresar
        notifications(group="auth" position="top center")

        b-form-group(label="Correo electrónico" label-for="user-email")
          b-form-input.field.form-control(v-model.trim="email" name="email" type="email"
            placeholder="usuario@recorrido.cl" id="user-email")
        b-form-group(label="Contraseña" label-for="user-password")
          b-form-input.field.form-control(v-model.trim="password" name="password" type="password"
            placeholder="******" id="user-password")
        .text-center.form-group
            button.btn.btn-default.btn-primary.btn-lg Iniciar sesión
    b-col(md="4")
</template>

<script>
import router from '@/router';
import store from '@/store';
import constants from '@/constants/Url.constants';

export default {
  name: 'login',
  data() {
    return {
      loader: false,
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      this.loader = true;
      this.infoError = false;
      this.$http.post(constants.TOKEN_URL, {
        auth: {
          email: this.email,
          password: this.password,
        },
      }).then((response) => {
        store.commit('login', response.body.jwt);
        router.push('/complaints');
      }, (response) => {
        const error = response.status === 423 ? 'Cuenta inactiva' : 'El inicio de sesión falló. Inténtalo de nuevo.';
        this.$notify({
          group: 'auth',
          type: 'error',
          title: 'Error',
          text: error,
          duration: 10000,
        });
        this.loader = false;
        this.password = '';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn-primary {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue